module.exports = __webpack_public_path__ + "img/5_88.2a9850d4.png";